export const isUnregistered = () => {
  const { ccpaFlow } = window.reactGlobals;

  if (ccpaFlow && typeof ccpaFlow === "string") {
    const flowType = ccpaFlow.toLowerCase();

    if (
      flowType === "guest" ||
      flowType === "ivr_unregistered" ||
      flowType === "former" ||
      flowType === "wireline_unregistered"
    ) {
      return true;
    }
  }
  return false;
};
